<template lang="pug">
v-container.disabled-alternate(v-if="chatVideo")
  video-player(
    v-if="this.chatVideo.file_url"
    :videoSrc="this.chatVideo.file_url"
    :thumbnailUrl="this.chatVideo.thumbnail_url"
    :videoUuid="chatVideo.uuid"
    :isSlideDrawerActive="isSlideDrawerActive"
    :videoComponentType="videoComponentType"
  )
  div.missing-video(v-if="!this.chatVideo.file_url")
    v-icon(x-large) broken_image
  v-text-field(
    label="Title"
    v-model="chatVideo.title"
    :disabled="!isVideoEditable"
    prepend-icon="notes"
    @input="onInput"
  )
  v-text-field(
    label="Description"
    v-model="chatVideo.description"
    :disabled="!isVideoEditable"
    prepend-icon="notes"
    @input="onInput"
  )
  tags-picker(
    :disabled="!isVideoEditable"
    :tags-list="tags"
    @save:tag="createTag"
    @update:searchInput="findTags"
    @input="updateTags"
    v-model="currentVideoTags"
  )
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import VideoPlayer from '@/Core/components/VideoPlayer';
import TagsPicker from '@/Core/components/TagsPicker';

const {
  mapActions: mapContactActions,
  mapState: mapContactState,
} = createNamespacedHelpers('contact');


export default {
  components: {
    VideoPlayer,
    TagsPicker,
  },
  props: {
    chatVideo: Object,
    showVideoDetail: Boolean,
    isVideoEditable: {
      type: Boolean,
      default: false,
    },
    isEmailComposer: {
      type: Boolean,
      default: false,
    },
    isSlideDrawerActive: Boolean,
    videoComponentType: String,
  },
  data() {
    return {
      currentVideoTags: [],
    };
  },
  methods: {
    ...mapContactActions(['createTag', 'findTags']),
    onInput() {
      this.$emit('modified:video');
    },
    updateTags(newTags) {
      this.chatVideo.tags = newTags.map((tag, index) => { return { id: index, content: tag }; });
    },
  },
  computed: {
    ...mapContactState(['tags']),
    drawerTitle() {
      return this.isVideoEditable ? 'Edit' : 'Preview';
    },
  },
  watch: {
    chatVideo: {
      immediate: true,
      handler(newValue) {
        this.findTags();

        let videoTags = [];
        if (this.chatVideo && this.chatVideo.tags) {
          videoTags = this.chatVideo.tags.map(tag => tag.content);
        }
        this.currentVideoTags = videoTags;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  .editButton {
    color: var(--v-primary-base)
  }
  .missing-video {
    max-width: 640px;
    height: 360px;
    margin-bottom: 35px;
    background: var(--v-background-lighten2);
    .v-icon {
      margin-left: 47%;
      margin-top: 25%;
      background: transparent;
    }
  }
</style>
